/* eslint-disable filenames/match-exported */
/* eslint-disable filenames/match-regex */

import * as d3 from 'd3';

import ChartTooltip from '@/chart/chartTooltip';

export default class ChartDataDetails {
  data = null;
  xKey = null;
  yKey = null;
  color = 'black';
  // Used for BAR CHART
  fill_color = '#E9EDF7';
  group = null;
  #tooltip = null;

  #circleOnHoverElement = null;
  #verticalLineOnHoverElement = null;

  xAxisTicks = null;
  xAxisScaleType = null;

  constructor(data, xKey, yKey, options = {}) {
    this.data = data;
    this.xKey = xKey;
    this.yKey = yKey;

    const defaults = {
      xAxisTicks: null,
      xScaleType: null,
    };

    options = Object.assign({}, defaults, options);
    this.xAxisTicks = options.xAxisTicks;
    this.xScaleType = options.xScaleType;
  }

  set tooltip(value) {
    if (!(value instanceof ChartTooltip)) {
      throw new Error('Invalid tooltip details.');
    }

    this.#tooltip = value;
  }

  get tooltip() {
    return this.#tooltip;
  }

  set verticalLineOnHoverElement(value) {
    this.#verticalLineOnHoverElement = value;

    this.hideOnHoverDetails();
  }

  get verticalLineOnHoverElement() {
    return this.#verticalLineOnHoverElement;
  }

  set circleOnHoverElement(value) {
    this.#circleOnHoverElement = value;

    this.hideOnHoverDetails();
  }

  get circleOnHoverElement() {
    return this.#circleOnHoverElement;
  }

  updateDynamicDetails(event, xScale, yScale, index, total, elementWidth) {
    if (!this.#tooltip) {
      return;
    }

    let i = 0;
    let mouseXPos = d3.pointer(event)[0];
    if (typeof xScale.invert === 'function') {
      mouseXPos = xScale.invert(mouseXPos);
      i = this.#tooltip.bisect(this.data, mouseXPos);
    }
    else if (this.xScaleType == 'scaleBand' || this.xScaleType == 'scalePoint') {
      // const domain = xScale.domain();
      const range = xScale.range();
      const rangePoints = d3.range(range[0], range[1], xScale.step());
      const scalePointExtent = d3.extent(rangePoints);
      const twoPointDistance = rangePoints[1] - rangePoints[0];
      const scalePointMouseXCorrection = (twoPointDistance * -1) + scalePointExtent[0];
      i = d3.bisect(rangePoints, (mouseXPos + scalePointMouseXCorrection));
    }

    const xPos = xScale(this.data[i][this.xKey]);
    const yPos = yScale(this.data[i][this.yKey]);

    if (this.#tooltip) {
      let groupXOffset = 0;
      if (total > 1) {
        groupXOffset = (index * elementWidth + (elementWidth / 2)) - (total * elementWidth / 2);
      }

      const isDateObj = this.data[i][this.xKey] instanceof Date;
      this.#tooltip.draw(
        xPos + groupXOffset,
        yPos,
        isDateObj ? this.data[i][this.xKey].toISOString().split('T')[0] : this.data[i][this.xKey],
        this.data[i][this.yKey],
      );
    }

    if (this.circleOnHoverElement) {
      this.circleOnHoverElement.style('display', null);
      this.circleOnHoverElement.attr('transform', `translate(${xPos}, ${yPos})`);
    }

    if (this.verticalLineOnHoverElement) {
      this.verticalLineOnHoverElement.style('display', null);
      this.verticalLineOnHoverElement.attr('transform', `translate(${xPos}, 0)`);
    }
  }

  hideOnHoverDetails() {
    if (this.circleOnHoverElement) {
      this.circleOnHoverElement.style('display', 'none');
    }

    if (this.verticalLineOnHoverElement) {
      this.verticalLineOnHoverElement.style('display', 'none');
    }

    if (this.#tooltip) {
      this.#tooltip.hide();
    }
  }
}
